module.exports = __webpack_public_path__ + "static/media/Internationalpic3@3x.3f8bb7d6.png";